<template>
  <router-link
    :to="{ name: 'Model', params: { range: range.id } }"
    class="range"
  >
    <div class="range__img">
      <img
        :alt="range.label"
        :src="imageManager().picture(range.menu_photo, 'min2')"
      />
    </div>
    <span class="range__title">
      <span v-if="range.label === 'Aixam Pro'" class="range__label">{{
        range.label
      }}</span>
      <span v-else class="range__label">
        <span class="e-aixam -model" v-html="processVehicleLabel()"></span>
      </span>
      <span v-if="range.energies" class="range__sub">{{
        range.energies.join(" - ")
      }}</span>
      <span v-if="range.fromInstallment" class="range__price">
        {{
          getTranslation(276, {
            PRICE: formatPrice(range.fromInstallment),
            CURRENCY: currency,
          })
        }}
      </span>
    </span>
  </router-link>
</template>

<script>
import { priceManager } from "@/services/price-manager";
import { vehicleManager } from "@/services/vehicle-manager";
import { getTranslation } from "@/services/translation-manager";
import { mapState } from "pinia";
import { useMainStore } from "@/store";
import { imageManager } from "@/services/image-manager";

export default {
  name: "RangeCardComponent",
  props: {
    range: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useMainStore, {
      currency: (store) => store.currency,
    }),
  },
  methods: {
    imageManager() {
      return imageManager;
    },
    getTranslation,
    formatPrice(price) {
      return priceManager.format(price);
    },

    processVehicleLabel() {
      return vehicleManager.processLabel(this.range.label);
    },
  },
};
</script>

<style lang="scss" scoped>
.range {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  max-width: 292px;
  margin-bottom: 35px;

  &__img {
    width: 100%;
    margin-bottom: 25px;
    position: relative;
    display: block;

    img {
      width: 100%;
      position: relative;
    }

    &:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      right: 0;
      background: rgba(255, 255, 255, 0.3);
      width: 85%;
      height: 25px;
      border-radius: 50%;
    }
  }

  &__title {
    border-left: 1px solid $white;
    display: block;
    padding-left: 20px;
    text-align: left;
  }

  &__label {
    font-size: 40px;
    text-transform: uppercase;
    font-weight: 700;
    line-height: 0.7;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }

  &__sub {
    display: block;
    font-weight: 300;
    font-size: 16px;
    line-height: 1.38;
  }

  &__price {
    font-weight: 500;
    display: block;
    margin-top: 10px;
    font-size: 20px;
    line-height: 1.1;
  }
}
</style>
